module.exports = __webpack_public_path__ + "img/19.e965b61d.webp";